import { makeStyles } from '@mui/styles';

export const useEventHistoryStyles = makeStyles({
  card: {
    padding: '16px',
    borderRadius: '10px',
    height: 'max-content'
  }
});
